import React from "react";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";

/**
 * Sim / Não / Todos.
 *
 * O valor é sempre texto — `""`, `"true"`, `"false"` — e nunca um booleano.
 * Com booleanos, o estado «todos» era `false` ou `undefined` e o MUI punha a
 * caixa vazia enquanto o servidor filtrava por `false`: o ecrã dizia «todos» e
 * mostrava metade das linhas. O servidor converte com `triEstado`.
 */
function SelectTriEstado({
  label,
  value = "",
  onChange,
  largura = 140,
  rotuloSim = "Sim",
  rotuloNao = "Não",
}) {
  return (
    <FormControl sx={{ width: largura }} size="small">
      <InputLabel>{label}</InputLabel>
      <Select
        value={value}
        label={label}
        onChange={(e) => onChange(e.target.value)}
      >
        <MenuItem value="">Todos</MenuItem>
        <MenuItem value="true">{rotuloSim}</MenuItem>
        <MenuItem value="false">{rotuloNao}</MenuItem>
      </Select>
    </FormControl>
  );
}

export default SelectTriEstado;
